import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import AddBookPublisher from '../../bookPublisher/addBookPublisher';
import AddProductCategory from '../../productCategory/addProductCategory';

const ProductModals = ({ 
  isAdd, 
  type, 
  prefillPublisherText, 
  prefillCategoryText, 
  onCloseAdd 
}) => {
  if (!isAdd) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '0%',
      left: '0%',
      right: '0%',
      bottom: '0%',
      backgroundColor: '#000000bd',
      zIndex: '100',
      height: '100%'
    }}>
      <div style={{
        position: 'relative',
        backgroundColor: 'white',
        margin: '10% 17%',
        width: '65%',
        backgroundColor: 'white'
      }}>
        <CloseCircleOutlined 
          style={{ float: 'right', fontSize: '20px' }} 
          onClick={() => onCloseAdd()} 
        />
        {type !== 'publisher' && (
          <AddProductCategory 
            prefillText={prefillCategoryText} 
            onSuccess={() => onCloseAdd(true)} 
          />
        )}
        {type === 'publisher' && (
          <AddBookPublisher 
            prefillText={prefillPublisherText} 
            onSuccess={() => onCloseAdd(true)} 
          />
        )}
      </div>
    </div>
  );
};

export default ProductModals;
